import React from 'react';
import useClasses from '../../hooks/useClasses';

import Icon from '../Icon';

import './style.scss';

interface Props {
  className?: string;
  exerciseStatus?: 'done' | 'lastExerciseDone' | 'start' | 'end' | 'locked' | 'available';
}

const LinePart: React.FC<Props> = ({
  className,
  exerciseStatus,
}) => {
  const { buildClass, joinClasses } = useClasses('LinePart', exerciseStatus);

  const arrayOfOptions = ['done', 'lastExerciseDone'];

  const showIcon = arrayOfOptions.includes(exerciseStatus);

  return (
    <div className={joinClasses(buildClass(), className)}>
      <div className={buildClass('dot')}>
        <div className={buildClass('icon-container')}>
          {showIcon && <Icon icon="checkmark" variant="9" size="xs" />}
        </div>
      </div>
      <div className={buildClass('line')} />
    </div>
  );
};

export default LinePart;
